import React, { useState } from 'react'
import { Colors, Intent, Menu, Spinner } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import { LeftMenuItem } from '../layout/LeftMenuItem'
import { subscriptionCustomerPortal } from '../../services/subscriptionApi';
import { redirectToExternal } from '../subscription/utils';
import {useCurrentUser, useSubscription} from '../../hooks';
import {isAdmin} from '../../utils/auth';

const Loading = React.memo(() => <Spinner intent={Intent.NONE} size={18} />);

export const GlobalSettingsTab = () => {
  /*
   * currentWorkspace - loaded in App.tsx
   */
  const subscription = useSubscription();

  const [ loadingBillingBtn, setLoadingBillingBtn ] = useState(false);
  const hasSubscription = !!subscription?.subscription_id;
  const hasCustomer = !!subscription?.customer_id;
  const currentUser = useCurrentUser();
  const userIsAdmin = isAdmin(currentUser);

  const onBillingClick = () => {
    setLoadingBillingBtn(true);

    subscriptionCustomerPortal()
      .then((data: any) => redirectToExternal(data.redirect_url, false))
      .catch(() => setLoadingBillingBtn(false));
  }

  return (
    <>
    <div className="sidebar__header">
          <h4 className="title-text">Administration</h4>
    </div>
    <Menu className="global-notebooks-left-menu__lists" data-cy='leftMenuSavedViews'>
      {
        userIsAdmin && (
          <LeftMenuItem
            icon={IconNames.COG}
            iconColor={Colors.GRAY4}
            label="Account Settings"
            link={`/a/o`}
          />
        )
      }
      <LeftMenuItem
        icon={IconNames.PEOPLE}
        iconColor={Colors.GRAY4}
        label="User Management"
        link={`/a/u`}
      />
      <LeftMenuItem
        icon={IconNames.PEOPLE}
        iconColor={Colors.GRAY4}
        label="User Groups"
        link={`/a/g`}
      />
      {
        userIsAdmin && (hasSubscription || hasCustomer) && (
          loadingBillingBtn ?
            <Loading /> :
            <LeftMenuItem
              icon={IconNames.CREDIT_CARD}
              iconColor={Colors.LIGHT_GRAY1}
              label="Billing & Invoices"
              onSelect={onBillingClick}
            />
        )
      }
    </Menu>

    </>
  )
}
